import { readonly, ref } from 'vue'

/**
 * 页面 load 事件是否已经触发。
 *
 * 为什么要等它：微信只在 WeixinJSBridge 回调里放行视频自动播放，而这个桥接通常要等页面
 * load（顶部绿色进度条走完）才就绪。首屏以下的大图、精灵图、助手脚本只要在 load 之前开始下载，
 * 就会把 load 往后拖，首屏视频也跟着晚播。所以这些非首屏资源统一等 load 之后再请求。
 *
 * 兜底：极端情况下 load 迟迟不来（比如某个首屏资源卡住），8 秒后也放行，避免下面的图一直空着。
 */
const loaded = ref(typeof document !== 'undefined' && document.readyState === 'complete')

if (typeof window !== 'undefined' && !loaded.value) {
  const done = () => {
    if (loaded.value) return
    // 让出一帧：load 回调里还有微信桥接、视频起播在排队，别跟它们抢
    window.setTimeout(() => { loaded.value = true }, 50)
  }
  window.addEventListener('load', done, { once: true })
  window.setTimeout(done, 8000)
}

export function usePageLoaded() {
  return readonly(loaded)
}
